/* ============================================================
   Aurore — Wishlist  |  assets/wishlist.js
   Bootstrapped from theme.liquid and lazy-loaded when needed.
   Do NOT add a second <script> tag in page.wishlist.liquid.
   ============================================================ */

(function () {
  'use strict';

  var KEY = 'aurore_wishlist_ids';
  var LIVE_COLLECTION_URL = '/collections/all-jewelry/products.json?limit=250';
  var liveCatalogPromise = null;

  function centsFromAny(value) {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return Math.round(value);
    var text = String(value).trim();
    if (!text) return 0;
    if (text.indexOf('.') !== -1) return Math.round(parseFloat(text) * 100);
    var digits = text.replace(/[^\d-]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function dedupeEntries(entries) {
    var map = {};
    (entries || []).forEach(function (entry) {
      if (!entry || !entry.id) return;
      var id = String(entry.id);
      map[id] = Object.assign({}, map[id] || { id: id }, entry, { id: id });
    });
    return Object.keys(map).map(function (id) { return map[id]; });
  }

  function normalizeStoredEntry(item) {
    if (item === null || item === undefined) return null;
    if (typeof item === 'string' || typeof item === 'number') {
      return { id: String(item) };
    }
    if (typeof item !== 'object' || !item.id) return null;
    return {
      id: String(item.id),
      title: item.title || '',
      url: item.url || '',
      handle: item.handle || '',
      image: item.image || '',
      price: centsFromAny(item.price),
      compareAtPrice: centsFromAny(item.compareAtPrice),
      variantId: item.variantId ? String(item.variantId) : '',
      variantTitle: item.variantTitle || '',
      type: item.type || '',
      autoDiscountPercent: item.autoDiscountPercent || 0
    };
  }

  function getEntries() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY)) || [];
      if (!Array.isArray(raw)) return [];
      return dedupeEntries(raw.map(normalizeStoredEntry).filter(Boolean));
    } catch (e) {
      return [];
    }
  }

  function setEntries(entries) {
    var normalized = dedupeEntries((entries || []).map(normalizeStoredEntry).filter(Boolean));
    try { localStorage.setItem(KEY, JSON.stringify(normalized)); }
    catch (e) {}
    document.dispatchEvent(new CustomEvent('aurore:wishlist:changed', {
      detail: { ids: normalized.map(function (entry) { return entry.id; }), entries: normalized }
    }));
  }

  /* ─────────────────────────────────────────
     1. STORAGE  — saves product IDs as array
     ───────────────────────────────────────── */
  function getIds() {
    return getEntries().map(function (entry) { return entry.id; });
  }

  function setIds(ids) {
    var existing = getEntries();
    var map = {};
    existing.forEach(function (entry) { map[entry.id] = entry; });
    setEntries((ids || []).map(function (id) { return map[String(id)] || { id: String(id) }; }));
  }

  function isSaved(id) {
    return getIds().indexOf(String(id)) !== -1;
  }

  function save(id, snapshot) {
    id = String(id);
    var entries = getEntries();
    var found = false;
    entries = entries.map(function (entry) {
      if (entry.id !== id) return entry;
      found = true;
      return Object.assign({}, entry, normalizeStoredEntry(Object.assign({ id: id }, snapshot || {})) || { id: id });
    });
    if (!found) entries.push(normalizeStoredEntry(Object.assign({ id: id }, snapshot || {})) || { id: id });
    setEntries(entries);
  }

  function unsave(id) {
    id = String(id);
    setEntries(getEntries().filter(function (entry) { return entry.id !== id; }));
  }

  function parsePriceFromText(text) {
    if (!text) return 0;
    var match = String(text).replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/);
    if (!match) return 0;
    return Math.round(parseFloat(match[1]) * 100);
  }

  function productUrlFromButton(btn) {
    if (!btn || !btn.closest) return '';
    var explicit = btn.dataset.productUrl || btn.dataset.url || '';
    if (explicit) return explicit;
    var scopedLink = btn.closest('.aur-product-card, .aur-p-card, .card, .card-wrapper, .product-card, .grid__item');
    var link = scopedLink ? scopedLink.querySelector('a[href*="/products/"]') : null;
    if (!link) link = btn.closest('a[href*="/products/"]');
    return link ? link.getAttribute('href') || '' : '';
  }

  function imageFromButton(btn) {
    if (!btn || !btn.closest) return '';
    if (btn.dataset.productImage) return btn.dataset.productImage;
    var scoped = btn.closest('.aur-product-card, .aur-p-card, .card, .card-wrapper, .product-card, .grid__item, .product__media-wrapper, .product__info-wrapper');
    var img = scoped ? scoped.querySelector('img') : null;
    return img ? (img.currentSrc || img.src || '') : '';
  }

  function titleFromButton(btn) {
    if (!btn || !btn.closest) return '';
    if (btn.dataset.title) return btn.dataset.title;
    var scoped = btn.closest('.aur-product-card, .aur-p-card, .card, .card-wrapper, .product-card, .grid__item, .product__info-wrapper');
    var el = scoped && scoped.querySelector('.aur-card-name, .aur-p-card-name, .card-name, .product__title, h1, h2, h3');
    return el ? el.textContent.trim() : '';
  }

  function typeFromButton(btn) {
    if (!btn || !btn.closest) return '';
    if (btn.dataset.productType) return btn.dataset.productType;
    var scoped = btn.closest('.aur-product-card, .aur-p-card, .card, .card-wrapper, .product-card, .grid__item, .product__info-wrapper');
    var el = scoped && scoped.querySelector('.aur-card-material, .aur-p-card-material, .card-material');
    return el ? el.textContent.trim() : '';
  }

  function priceFromButton(btn) {
    if (!btn || !btn.closest) return 0;
    if (btn.dataset.priceCents) return centsFromAny(btn.dataset.priceCents);
    var scoped = btn.closest('.aur-product-card, .aur-p-card, .card, .card-wrapper, .product-card, .grid__item, .product__info-wrapper');
    var el = scoped && scoped.querySelector('.aur-price, .price-item--sale, .price-item--regular, .product__price, .price');
    return el ? parsePriceFromText(el.textContent) : 0;
  }

  function variantIdFromButton(btn) {
    if (!btn || !btn.closest) return '';
    if (btn.dataset.variantId) return String(btn.dataset.variantId);
    var form = btn.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var input = form ? form.querySelector('input[name="id"]') : null;
    return input && input.value ? String(input.value) : '';
  }

  function variantTitleFromButton(btn) {
    if (!btn || !btn.closest) return '';
    if (btn.dataset.variantTitle) return btn.dataset.variantTitle;
    var form = btn.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return '';
    var inputs = form.querySelectorAll('input[name^="options["]:checked, select[name^="options["]');
    var values = [];
    inputs.forEach(function (input) {
      var value = input.value || '';
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values.join(' / ');
  }

  function snapshotFromButton(btn) {
    if (!btn) return null;
    var id = String(btn.dataset.productId || btn.getAttribute('data-product-id') || '');
    if (!id || id === '0') return null;
    var url = productUrlFromButton(btn);
    var handle = btn.dataset.productHandle || (url && url.indexOf('/products/') !== -1 ? url.split('/products/').pop().split('?')[0].split('#')[0] : '');
    return normalizeStoredEntry({
      id: id,
      title: titleFromButton(btn),
      url: url,
      handle: handle,
      image: imageFromButton(btn),
      price: priceFromButton(btn),
      compareAtPrice: btn.dataset.compareAtPriceCents || '',
      variantId: variantIdFromButton(btn),
      variantTitle: variantTitleFromButton(btn),
      type: typeFromButton(btn)
    });
  }

  function hydrateEntriesFromVisibleButtons() {
    var entries = getEntries();
    var changed = false;
    var byId = {};
    entries.forEach(function (entry) { byId[entry.id] = entry; });
    document.querySelectorAll('[data-product-id]').forEach(function (btn) {
      var snapshot = snapshotFromButton(btn);
      if (!snapshot || !byId[snapshot.id]) return;
      var merged = Object.assign({}, byId[snapshot.id], snapshot);
      var previous = JSON.stringify(byId[snapshot.id]);
      var next = JSON.stringify(merged);
      if (previous !== next) {
        byId[snapshot.id] = merged;
        changed = true;
      }
    });
    if (changed) setEntries(Object.keys(byId).map(function (id) { return byId[id]; }));
  }

  /* ─────────────────────────────────────────
     2. aurWishToggle  — global onclick handler
        Attach via: onclick="aurWishToggle(this, event)"
        THIS is the only definition. Do NOT redefine it
        in any section's inline <script>.
     ───────────────────────────────────────── */
  window.aurWishToggle = function (btn, event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }

    var id    = String(btn.dataset.productId || btn.getAttribute('data-product-id') || '');
    if (!id || id === '0') return; /* guard placeholder cards */
    var snapshot = snapshotFromButton(btn);

    var saved = isSaved(id);

    if (saved) {
      unsave(id);
      setButtonState(btn, false);
      aurShowToast('\u2661', 'Removed from wishlist');
    } else {
      save(id, snapshot);
      setButtonState(btn, true);
      animateBtn(btn);
      aurShowToast('\u2665', 'Saved to wishlist');
    }

    refreshBadges();
  };

  /* ─────────────────────────────────────────
     3. Button state helpers
     ───────────────────────────────────────── */
  function setButtonState(btn, saved) {
    btn.dataset.saved = saved ? 'true' : 'false';
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label',
      saved
        ? (btn.dataset.title ? 'Remove ' + btn.dataset.title + ' from wishlist' : 'Remove from wishlist')
        : (btn.dataset.title ? 'Save '   + btn.dataset.title + ' to wishlist'   : 'Save to wishlist')
    );
    btn.innerHTML    = saved ? '&#9829;' : '&#9825;';
    btn.style.color  = saved ? '#C84B4B' : '';
  }

  function animateBtn(btn) {
    btn.style.transition = 'transform .18s ease';
    btn.style.transform  = 'scale(1.4)';
    setTimeout(function () { btn.style.transform = 'scale(1)'; }, 200);
  }

  /* ─────────────────────────────────────────
     4. Sync ALL .aur-wish-btn on current page
     ───────────────────────────────────────── */
  function syncAllButtons() {
    document.querySelectorAll('.aur-wish-btn[data-product-id]').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (!id || id === '0') return;
      setButtonState(btn, isSaved(id));
    });
  }

  /* ─────────────────────────────────────────
     5. Shared toast
        Renders one toast in theme.liquid:
        <div class="aur-toast" id="aur-toast-global" role="status" aria-live="polite">
          <span class="aur-toast-icon"></span>
          <span class="aur-toast-msg"></span>
        </div>
        Falls back to any .aur-toast found in DOM.
     ───────────────────────────────────────── */
  var _toastTimer;
  window.aurShowToast = function (icon, msg) {
    clearTimeout(_toastTimer);
    var toast = document.getElementById('aur-toast-global')
             || document.querySelector('.aur-toast');
    if (!toast) return;
    toast.querySelector('.aur-toast-icon').textContent = icon;
    toast.querySelector('.aur-toast-msg').textContent  = msg;
    toast.classList.add('is-show');
    _toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, 2800);
  };

  /* ─────────────────────────────────────────
     6. Nav count badge
        Usage: <span data-wishlist-count></span>
     ───────────────────────────────────────── */
  function refreshBadges() {
    var count = getIds().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent   = count > 0 ? count : '';
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ─────────────────────────────────────────
     7. Money formatter
        Requires window.AuroreMoneyFormat injected
        in theme.liquid:
          <script>
            window.AuroreMoneyFormat = {{ shop.money_format | json }};
          </script>
     ───────────────────────────────────────── */
  function money(cents) {
    var val = parseInt(cents, 10);
    if (isNaN(val)) return '';
    var fmt    = (window.AuroreMoneyFormat || '${{amount}}');
    var amount = (val / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountNoDecimals = String(Math.round(val / 100));
    return fmt
      .replace('{{amount}}',             amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  function normalizeLiveProduct(product) {
    if (!product || !product.id) return null;
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;
    var image = product.images && product.images[0] ? product.images[0] : '';
    return {
      id   : String(product.id),
      title: product.title || '',
      price: variant ? centsFromAny(variant.price) : centsFromAny(product.price || ''),
      type : product.product_type || product.type || '',
      image: image && image.src ? image.src : image,
      url  : '/products/' + (product.handle || ''),
      handle: product.handle || '',
      compareAtPrice: variant ? centsFromAny(variant.compare_at_price) : centsFromAny(product.compare_at_price || ''),
      variantId: variant && variant.id ? String(variant.id) : '',
      variantTitle: variant ? (variant.title || '') : ''
    };
  }

  function fetchLiveCatalog() {
    if (liveCatalogPromise) return liveCatalogPromise;
    liveCatalogPromise = fetch(LIVE_COLLECTION_URL, {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        return response.ok ? response.json() : Promise.reject(response);
      })
      .then(function (data) {
        var products = data && Array.isArray(data.products) ? data.products : [];
        return products.map(normalizeLiveProduct).filter(Boolean);
      })
      .catch(function () {
        return [];
      });
    return liveCatalogPromise;
  }

  /* ─────────────────────────────────────────
     8. WISHLIST PAGE RENDERER
        Only activates when #wl-grid exists.
     ───────────────────────────────────────── */
  function isWishlistPage() {
    return !!document.getElementById('wl-grid');
  }

  /* ── show / hide helpers ── */
  function show(el) { if (el) el.classList.remove('wl-hidden'); }
  function hide(el) { if (el) el.classList.add('wl-hidden'); }

  function getEls() {
    return {
      grid   : document.getElementById('wl-grid'),
      empty  : document.getElementById('wl-empty'),
      toolbar: document.getElementById('wl-toolbar'),
      count  : document.getElementById('wl-count'),
      clear  : document.getElementById('wl-clear-btn'),
      loader : document.getElementById('wl-loader'),
      share  : document.getElementById('wl-share'),
      input  : document.getElementById('wl-share-url'),
      copy   : document.getElementById('wl-copy-btn'),
      note   : document.getElementById('wl-copy-note'),
      tmpl   : document.getElementById('wl-card-template')
    };
  }

  function showEmpty(els) {
    hide(els.loader); hide(els.grid); hide(els.toolbar); hide(els.share);
    show(els.empty);
  }
  function showLoader(els) {
    hide(els.empty); hide(els.grid); hide(els.toolbar); hide(els.share);
    show(els.loader);
  }
  function showGrid(els) {
    hide(els.empty); hide(els.loader);
    show(els.grid); show(els.toolbar); show(els.share);
  }

  /* ─────────────────────────────────────────
     Resolve saved products from the live
     all-jewelry collection feed by numeric ID.
     Shopify does not support /products/<id>.json.
     ───────────────────────────────────────── */
  function fetchById(id) {
    id = String(id);
    return fetchLiveCatalog()
      .then(function (products) {
        for (var i = 0; i < products.length; i += 1) {
          if (products[i] && products[i].id === id) return products[i];
        }
        return null;
      })
      .catch(function () { return null; });
  }

  /* ── render the wishlist page ── */
  function renderPage() {
    if (!isWishlistPage()) return;

    var els = getEls();

    /* Support shared ?wl= URL parameter */
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('wl');
    var ids    = shared
      ? shared.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
      : getIds();

    if (!ids.length) { showEmpty(els); return; }

    showLoader(els);

    Promise.all(ids.map(fetchById))
      .then(function (products) {
        /* Preserve saved order, drop failed fetches */
        var valid = ids
          .map(function (id) {
            return products.find(function (p) { return p && p.id === id; }) || null;
          })
          .filter(Boolean);

        if (!valid.length) { showEmpty(els); return; }

        /* Update count label */
        if (els.count) {
          els.count.textContent = valid.length +
            (valid.length === 1 ? ' item saved' : ' items saved');
        }

        /* Build cards */
        els.grid.innerHTML = '';
        valid.forEach(function (item, i) {
          els.grid.appendChild(buildCard(item, i, els));
        });

        /* Build share URL */
        if (els.input) {
          els.input.value =
            window.location.origin +
            window.location.pathname +
            '?wl=' + encodeURIComponent(valid.map(function (p) { return p.id; }).join(','));
        }

        showGrid(els);
      })
      .catch(function () { showEmpty(els); });
  }

  /* ── build one product card from <template> ── */
  function buildCard(item, idx, els) {
    var clone = els.tmpl.content.cloneNode(true);
    var card  = clone.querySelector('.wl-card');
    card.style.animationDelay = (idx * 0.06) + 's';

    var imgLink = clone.querySelector('.wl-card-img-link');
    var img     = clone.querySelector('.wl-card-img');
    var rmBtn   = clone.querySelector('.wl-remove-btn');
    var typeEl  = clone.querySelector('.wl-card-type');
    var nameEl  = clone.querySelector('.wl-card-name');
    var priceEl = clone.querySelector('.wl-card-price');
    var ctaEl   = clone.querySelector('.wl-card-cta');

    imgLink.href = item.url;
    imgLink.setAttribute('aria-label', item.title);

    if (item.image) {
      img.src = item.image;
      img.alt = item.title;
    } else {
      img.remove();
    }

    rmBtn.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
    rmBtn.addEventListener('click', function () {
      unsave(item.id);
      refreshBadges();
      document.querySelectorAll('.aur-wish-btn[data-product-id="' + item.id + '"]')
        .forEach(function (b) { setButtonState(b, false); });
      renderPage();
    });

    typeEl.textContent  = item.type || '';
    nameEl.textContent  = item.title;
    nameEl.href         = item.url;
    priceEl.textContent = item.price ? money(item.price) : '';
    ctaEl.href          = item.url;

    return clone;
  }

  /* ─────────────────────────────────────────
     9. Wishlist-page-only event listeners
        Gated so they only bind when on the page.
     ───────────────────────────────────────── */
  function initWishlistPage() {
    if (!isWishlistPage()) return;

    var els = getEls();

    /* Clear all */
    if (els.clear) {
      els.clear.addEventListener('click', function () {
        if (!confirm('Remove all saved items?')) return;
        setIds([]);
        refreshBadges();
        syncAllButtons();
        renderPage();
      });
    }

    /* Copy share link */
    if (els.copy && els.input) {
      els.copy.addEventListener('click', function () {
        els.input.select();
        els.input.setSelectionRange(0, 99999);
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(els.input.value).catch(function () {
            try { document.execCommand('copy'); } catch (e) {}
          });
        } else {
          try { document.execCommand('copy'); } catch (e) {}
        }
        if (els.note) {
          els.note.textContent = '\u2756  Link copied!';
          setTimeout(function () { els.note.textContent = ''; }, 2500);
        }
      });
    }

    renderPage();
  }

  /* ─────────────────────────────────────────
     10. Hover: show quick-add + wishlist icons
         (collection / featured section cards)
     ───────────────────────────────────────── */
  function initCardHover() {
    document.querySelectorAll('.aur-p-card').forEach(function (card) {
      var imgWrap = card.querySelector('.aur-p-card-img-wrap');
      if (!imgWrap) return;
      card.addEventListener('mouseenter', function () { imgWrap.classList.add('is-hovered'); });
      card.addEventListener('mouseleave', function () { imgWrap.classList.remove('is-hovered'); });
    });
  }

  /* ─────────────────────────────────────────
     11. INIT — runs on every page
     ───────────────────────────────────────── */
  function init() {
    hydrateEntriesFromVisibleButtons();
    syncAllButtons();
    refreshBadges();
    initCardHover();
    initWishlistPage(); /* no-op on non-wishlist pages */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
